import React from 'react';

const EposInactive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="18"
    viewBox="0 0 32 18"
    fill="none"
  >
    <g filter="url(#filter0_i)">
      <path
        d="M0 8.99988C0 13.9628 4.18799 18 9.33325 18H22.6667C27.812 18 32 13.9628 32 8.99988C32 4.03722 27.812 0 22.6667 0H9.33325C4.18799 0 0 4.03722 0 8.99988Z"
        fill="var(--DISABLED)"
      />
    </g>
    <path
      d="M14 8.99989C14 11.7613 11.7616 14 9.00011 14C6.23868 14 4 11.7613 4 8.99989C4 6.23845 6.23868 4 9.00011 4C11.7616 4 14 6.23845 14 8.99989Z"
      fill="var(--SECONDARY_LIGHT)"
    />
    <defs>
      <filter
        id="filter0_i"
        x="0"
        y="0"
        width="32"
        height="19"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
    </defs>
  </svg>
);

export default EposInactive;
